<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="sortedDocuments"
      :items-per-page="-1"
      :loading="loading"
      :loading-text="$t('order.documents.documentsLoading')"
      :no-data-text="$t('order.documents.noDocuments')"
      disable-sort
      hide-default-footer
      item-key="_id"
      mobile-breakpoint="768"
    >
      <template v-slot:item.name="{ item }">
        <a :href="item.url" target="_blank" rel="noopener noreferrer" class="document-link">
          {{ item.name }}
        </a>
      </template>

      <template v-slot:item.type="{ item }">
        <span class="document-type">{{ getDocTypeTranslation(item.type) }}</span>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
  import { getOrderDocTypeTranslation } from '../../helpers/helper'
  export default {
    name: 'orderDocumentsTable',
    props: {
      documents: {
        type: Array,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      headers() {
        return [
          {
            text: this.$t('order.documents.type'),
            value: 'type',
          },
          {
            text: this.$t('order.documents.name'),
            value: 'name',
          },
        ]
      },
      sortedDocuments() {
        let sortedDocuments = JSON.parse(JSON.stringify(this.documents))
        return sortedDocuments.sort((a, b) => {
          const order = {
            invoice: 1,
            credit_note: 2,
            warranty: 3,
            other: 4,
          }
          return order[a.type] - order[b.type]
        })
      },
    },
    methods: {
      getDocTypeTranslation(documentTypesTechnicalNames) {
        return getOrderDocTypeTranslation(documentTypesTechnicalNames)
      },
    },
  }
</script>
<style scoped>
  .document-link {
    text-transform: none;
    text-decoration: underline;
  }
  .document-type {
    text-transform: capitalize;
  }
</style>
